import React from 'react'

import Navbar2 from '../components/Navbar2/Component';
import CategoryView from '../components/CategoryView/Component';
import ProductGrid from '../components/ProductGrid/Component';
import OrderSummaryMobile from '../components/OrderSummaryMobile/Component';
import PaymentOptionsMobile from '../components/PaymentOptionsMobile/Component';


function HomePage2() {
  return (
  <>
  
  <Navbar2/>
  <CategoryView/>
  <ProductGrid/>
  <OrderSummaryMobile/>
  <PaymentOptionsMobile/>
  



  
  </>
  )
}

export default HomePage2
